import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../src/store';
import 'quill/dist/quill.snow.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		    {/* <BrowserRouter> */}
			<BrowserRouter basename='/smart-feedback'>
				<Provider store={store}>
					<App />
				</Provider>
			</BrowserRouter>
	</React.StrictMode>,
);

reportWebVitals();
